import { useState } from 'react'
import Swal from 'sweetalert2'
import MembershipsService from '@/services/MembershipsService'

export function useMembershipActions(loadMembershipsData) {
	const [isDeleting, setIsDeleting] = useState(false)

	const handleDeleteSelected = async (selectedMemberships, clearSelection) => {
		if (selectedMemberships.size === 0) {
			Swal.fire({
				title: 'No memberships selected',
				text: 'Please select memberships to delete',
				icon: 'warning',
			})
			return
		}

		const result = await Swal.fire({
			title: 'Are you sure?',
			text: `You are about to delete ${selectedMemberships.size} membership(s). This action cannot be undone!`,
			icon: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#d33',
			cancelButtonColor: '#3085d6',
			confirmButtonText: 'Yes, delete them!',
			cancelButtonText: 'Cancel',
		})

		if (result.isConfirmed) {
			setIsDeleting(true)
			try {
				const membershipIds = Array.from(selectedMemberships)
				const deleteResult = await MembershipsService.deleteMemberships(membershipIds)

				if (deleteResult.success) {
					Swal.fire({
						title: 'Deleted!',
						text: deleteResult.message || 'Memberships have been deleted successfully.',
						icon: 'success',
					})
					clearSelection()
					loadMembershipsData()
				} else {
					Swal.fire({
						title: 'Error!',
						text: deleteResult.error || 'Failed to delete memberships',
						icon: 'error',
					})
				}
			} catch (error) {
				console.error('Delete memberships error:', error)
				Swal.fire({
					title: 'Error!',
					text: 'An unexpected error occurred while deleting memberships',
					icon: 'error',
				})
			} finally {
				setIsDeleting(false)
			}
		}
	}

	return {
		isDeleting,
		handleDeleteSelected,
	}
}
